import React from 'react';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Logo from "@/components/logo";
import { ROUTE_STAMPING } from '@/utils/context/constants';

const ErrorView = () => {
  const renderHeader = (
    <Box
      component="header"
      sx={{
        top: 0,
        left: 0,
        width: 1,
        lineHeight: 0,
        position: "fixed",
        p: theme => ({ xs: theme.spacing(3, 3, 0), sm: theme.spacing(5, 5, 0) })
      }}
    >
      <Logo />
    </Box>
  );

  const goToStamping = () => {
    window.location.href = ROUTE_STAMPING;
  };

  return (
    <Container>
      {renderHeader}
      <Box
        sx={{
          py: 5,
          maxWidth: 480,
          mx: "auto",
          display: "flex",
          minHeight: "100vh",
          textAlign: "center",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center"
        }}
      >
        <Typography variant="h4" sx={{ mb: 2 }}>
          Qualcosa è andato storto!
        </Typography>

        <Typography sx={{ color: "text.secondary", mb: 5 }}>
          L'errore <strong>è stato registrato</strong>, verificheremo quanto prima.<br />
          I dati della bedgiatura, se già iniziata, <strong>potrebbero andare persi</strong>.<br />
          Intanto magari:
          <ul>
            <li>Se sei gi&agrave; loggato ritorna alla Home, esegui un logout e un successivo login</li>
            <li>Se non sei loggato, vai alla pagina di login e riesegui un login</li>
            <li>Oppure prova ad andare alla sezione bedgiature.</li>
          </ul>
        </Typography>

        <Stack direction="row" spacing={2} sx={{ mb: 1 }}>
          <Button
            href="/login"
            size="large"
            variant="outlined"
          >
            Login
          </Button>
          <Button
            href="/"
            size="large"
            variant="outlined"
          >
            Home
          </Button>
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={goToStamping}
          >
            Sezione badgiature
          </Button>
        </Stack>
 
        <Box
          component="img"
          src="/assets/illustrations/404_not_found.svg"
          sx={{
            mx: "auto",
            height: 260,
            my: { xs: 1, sm: 3 }
          }}
        />
      </Box>
    </Container>
  );
};

export default ErrorView;
